import type { ILimitedListItemModel } from "app/pages/sales-intelligence/modules/quota/types/limitedListItemModel";
import { LimitedListItemType } from "app/pages/sales-intelligence/modules/quota/types/limitedListItemModel";

import AllResultsWithCostDropdownItem from "../models/selection-dropdown-item/AllResultsWithCostDropdownItem/AllResultsWithCostDropdownItem";
import TopNWithCostDropdownItem from "../models/selection-dropdown-item/TopNWithCostDropdownItem/TopNWithCostDropdownItem";
import type { TopNWithCostDropdownItemDeps } from "../models/selection-dropdown-item/TopNWithCostDropdownItem/types";
import TopNWithCostRemainingDropdownItem from "../models/selection-dropdown-item/TopNWithCostRemainingDropdownItem/TopNWithCostRemainingDropdownItem";

export function mapLimitedListOfItemsToTopNWithCost(
    list: readonly ILimitedListItemModel[],
    modelOptions: Partial<Omit<TopNWithCostDropdownItemDeps, "cost" | "isAvailable" | "value" | "alias">> = {},
): readonly TopNWithCostDropdownItem[] {
    return list.map(({ value, type, cost, isAvailable }: ILimitedListItemModel) => {
        switch (type) {
            case LimitedListItemType.Remaining:
                return new TopNWithCostRemainingDropdownItem({
                    ...modelOptions,
                    id: `top-${value}`,
                    value,
                    cost,
                    isAvailable,
                });

            case LimitedListItemType.All:
                return new AllResultsWithCostDropdownItem({ ...modelOptions, value, cost, isAvailable });

            default:
                return new TopNWithCostDropdownItem({
                    ...modelOptions,
                    id: `top-${value}`,
                    value,
                    cost,
                    isAvailable,
                });
        }
    });
}
